import { createTheme, getTheme, ISeparatorStyles, ITheme,MessageBar,MessageBarType,PrimaryButton,ProgressIndicator,Separator,Stack, TextField, useTheme } from '@fluentui/react';
import * as React from 'react';
import LoginIcon from '../../../Images/LoginLogo';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { validateEmail } from '../../../Tools/Validation';

interface IEmailChangeViewProps {
    width: number;
    statusMessage?: IStatusMessage;
    oldEmail: string;
    email: string;
    emailConfirmation: string;
    isEmailVerified: boolean;
    onEmailChanged: (value: string) => void;
    onEmailConfirmationChanged: (value: string) => void;
    changeEmail: () => void;
    isLoading: boolean;
    canSave: boolean;


}
 

export const EmailChangeView: React.FunctionComponent<IEmailChangeViewProps> = (props) => {

    const emailChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        props.onEmailChanged(newValue ? newValue : "");
    }

    const emailConfirmationChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        props.onEmailConfirmationChanged(newValue ? newValue : "");
    }

    return (
        <Stack horizontalAlign="center">
            <Stack tokens={{ childrenGap: 15 }} styles={{ root: { width: props.width, paddingTop: 40  } }}>
                <Stack horizontalAlign="center" >
                    <LoginIcon />
                </Stack>
                <Separator styles={{ root: { marginTop: 0 } }}>Změna emailu</Separator>
                <Stack tokens={{ childrenGap: 15 }}>
                    <TextField label="Email" readOnly value={props.oldEmail}/>
                    <TextField label="Nový email" value={props.email}
                        onChange={emailChanged}
                        onGetErrorMessage={(value: string) => !validateEmail(value) && (value !== "") ? "Neplatný formát e-mailové adresy" : ""} />
                    <TextField label="Potvrzení" value={props.emailConfirmation}
                        onChange={emailConfirmationChanged}
                        onGetErrorMessage={(value: string) => !validateEmail(value) && (value!=="")? "Neplatný formát e-mailové adresy" : ""}  
                    />
                    <Stack styles={{ root: { paddingTop: 15 } }} horizontalAlign="center">
                        <PrimaryButton text="Uložit" onClick={props.changeEmail} disabled={props.isLoading || !props.canSave } />
                    </Stack>
                    {props.isLoading?<ProgressIndicator></ProgressIndicator>:null}
                    {props.statusMessage && props.statusMessage.message ? <MessageBar styles={{ root: { marginTop:20 } }} messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
            </Stack>
                </Stack>
        </Stack>
     )
}
